module.exports = __webpack_public_path__ + "img/logo.40272872.png";